export { default } from '@triptyk/ember-utils/utils/sanitize-string';
